import { api } from './api';

const cardGetPagedList = async ({data, pageNumber = 1, pageSize}) => {
    const response = await api({
        url: `Cards/getPagedCardsByUserRoleQuery`,
        method: 'POST',
        data: {
            page: pageNumber,
            pageSize,
            ...data,
        },
    });
    return response.data;
};

const checkEacContactInfo = async (data) => {
    const response = await api({
        url: `CardOrders/CheckContactInfo`,
        method: 'POST',
        data,
    });
    return response.data;
};

const sendEacCodeSms = async (data) => {
    const response = await api({
        url: `CardOrders/SendEacCodeSms`,
        method: 'POST',
        data,
    });
    return response.data;
};

const sendEacCodeEmail = async (data) => {
    const response = await api({
        url: `CardOrders/SendEacCodeEmail`,
        method: 'POST',
        data,
    });
    return response.data;
};

const processTypesGetPagedList = async (data) => {
    const response = await api({
        url: `ProcessTypes/getPagedList`,
        method: 'GET',
        params: {
            page: 1,
            pageSize: 0,
            ...data,
        },
    });
    return response.data;
};

const cardsCancelList = async (data) => {
    const response = await api({
        url: `Cards/cardCancelList`,
        method: 'POST',
        data,
    });
    return response.data;
};

const cardActivate = async (data) => {
    const response = await api({
        url: `Cards/activate`,
        method: 'POST',
        data,
    });
    return response.data;
};

const employeesUpdateList = async (data) => {
    const response = await api({
        url: `Employees/updateList`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const employeesUpdateAddressList = async (data) => {
    const response = await api({
        url: `Employees/updateAddressList`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const cancelRequestsDelete = async (data) => {
    const response = await api({
        url: `CancelRequests/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            ...data,
            customerId: window.customerId
        },
    });
    return response.data;
};

const updateMobilPayments = async (data) => {
    const response = await api({
        url: 'Cards/UpdateMobilePayments',
        method: 'PUT',
        data,
    });
    return response.data;
};

const updateMobilPaymentCollective = async (data) => {
    const response = await api({
        url: 'Cards/UpdateMobilePaymentCollective',
        method: 'PUT',
        data,
    });
    return response.data;
};

const manageCardsServices = {
  cardGetPagedList,
  checkEacContactInfo,
  sendEacCodeSms,
  sendEacCodeEmail,
  processTypesGetPagedList,
  cardsCancelList,
  cardActivate,
  employeesUpdateList,
  cancelRequestsDelete,
  updateMobilPayments,
  employeesUpdateAddressList,
  updateMobilPaymentCollective,
};

export default manageCardsServices;
